import React, { Component } from 'react';
import ShareTips from './ShareTips';
import SugeestAnEdit from './SuggestAnEdit';

export class SuggestionTipsContainer extends Component {
  state = {
    step: 1,
  };

  // Proceed to next step
  nextStep = () => {
    const { step } = this.state;
    this.setState({
      step: step + 1,
    });
  };

  // Go back to prev step
  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1,
      openDialog2: false,
    });
  };

  // Handle fields change
  handleChange = input => e => {
    this.setState({ openDialog2: true });
  };

  render() {
    const { step } = this.state;
    switch (step) {
      case 1:
        return (
          <ShareTips
            nextStep={this.nextStep}
            eateryData={this.props.eateryData}
            handleClose={this.props.onClose}
          />
        );
      case 2:
        return (
          <SugeestAnEdit
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            eateryData={this.props.eateryData}
            handleChange={this.handleChange}
            handleClose={this.props.onClose}
          />
        );
      default:
        return null;
    }
  }
}

export default SuggestionTipsContainer;
